import type { ProfileModel } from "../types/models";

// "pricing-default-monthly" experiment: which billing interval the pricing
// cards open on. Control keeps today's Yearly tab ($14/mo, billed $174 at
// checkout); the "monthly" arm opens on Monthly ($29/mo). Both arms can
// still switch tabs. Only the paywall/pricing default changes, never prices
// or checkout. Delete with the experiment.
//
// Sep 2026 trial-country checkouts: 76% started on Yearly. Users who only
// ever opened a yearly checkout paid 4.9% of the time, vs 41.5% for those
// who opened a monthly one first.

export type BillingInterval = "monthly" | "yearly";

export const MONTHLY_DEFAULT_FLAG_KEY = "pricing-default-monthly";

// Must equal the flag's signed_up_at release condition in PostHog.
export const MONTHLY_DEFAULT_EXPERIMENT_LAUNCH_DATE = new Date(
  "2026-10-06T08:00:00Z",
);

// Free, non-guest profiles created on/after the launch date. Subscribers
// keep opening on their own plan's interval, and logged-out /pricing
// visitors keep Yearly; neither evaluates the flag, so they are never
// exposed.
export const isMonthlyDefaultExperimentEligible = (
  profile?: Pick<ProfileModel, "plan" | "isGuest" | "createdAt"> | null,
): boolean =>
  !!profile &&
  !profile.isGuest &&
  !profile.plan &&
  !!profile.createdAt &&
  new Date(profile.createdAt) >= MONTHLY_DEFAULT_EXPERIMENT_LAUNCH_DATE;

// Anything but the "monthly" arm (control, not enrolled, flags not loaded)
// opens on Yearly, today's default.
export const billingIntervalForVariant = (
  variant: string | boolean | undefined | null,
): BillingInterval => (variant === "monthly" ? "monthly" : "yearly");
